import type { ReactNode } from 'react';
import React from 'react';

import styles from '../../statics/styles/image-viewer.rtlignore.scss';
import { ROOT } from '../dataHooks';
import type {
  ImageClickActionConfig,
  ImageClickActionHandle,
} from './get-image-click-action-config';

type ImageContainerProps = ImageClickActionConfig & {
  disableDownload?: ImageClickActionHandle;
  children: ReactNode;
};

export const ImageContainer = (props: ImageContainerProps) => {
  const { type, disableDownload, children } = props;

  const hasOnClick = 'onClick' in props;

  const onClick = hasOnClick ? props.onClick : undefined;

  const onKeyDown = onClick
    ? (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(e);
        }
      }
    : undefined;

  const interactions = {
    onClick,
    onKeyDown,
    onContextMenu: disableDownload,
  };

  const role = hasOnClick || (type === 'regular' && !!disableDownload) ? 'button' : undefined;
  const tabIndex = role === 'button' ? 0 : undefined;

  return (
    <figure
      {...(role === 'button' ? interactions : {})}
      role={role}
      data-hook={ROOT}
      tabIndex={tabIndex}
      className={styles.imageContainer}
      aria-haspopup={role === 'button' ? true : undefined}
    >
      {children}
    </figure>
  );
};
